import MojitoPresentation from 'mojito/presentation';

const { FlexPane, Text, Spinner } = MojitoPresentation.Components;

function BonusesLoadingIndicator(props) {
    const {
        labelClassName,
        mojitoTools: { config, stringResolver },
    } = props;

    return (
        <FlexPane config={config.container} class="ta-BonusesLoadingIndicator">
            <Text config={config.label} class={labelClassName}>
                {stringResolver.resolveString('$BONUSES.BONUSES_ARE_LOADING')}
            </Text>
            <Spinner config={config.spinner} />
        </FlexPane>
    );
}

export default BonusesLoadingIndicator;
